import { axiosWCApiInstance } from '../Configurations/AxiosConfiguration';

export const getDivisions = async (includeInactive = false, includeSGA = false) => {
    try {
        const response = await axiosWCApiInstance.get(
            `/divisions/?includeInactive=${includeInactive}&includeSGA=${includeSGA}`
        );
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export function dataURItoBlob(dataURI) {
    // Required for Chrome to display data url data
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    const [meta, base64] = dataURI.split(',');
    const mimeString = meta.match(/:(.*?);/)[1]; // Extract MIME type
    const byteString = atob(base64);
    const uintArray = new Uint8Array(byteString.length).map((_, i) => byteString.charCodeAt(i));

    return new Blob([uintArray], { type: mimeString });
}
